import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import {
    Notification,
    NotificationCategory,
    NotificationStatus,
} from '@@api/services/notification/schemas';
import { PaginationParams, SearchParams } from '@@api/utils/schemas/queryParams';
import { paginated } from '@@api/utils/schemas/utils';
import config from '@@config';

export const notificationService = defineService(
    (defineEndpoint) => ({
        categories: {
            get: defineEndpoint({
                method: 'GET',
                path: '/categories',
                query: z.object({
                    ...SearchParams.pick({ tenantIds: true }).shape,
                }),
                responses: {
                    200: z.array(NotificationCategory),
                },
            }),
        },
        content: {
            getAll: defineEndpoint({
                method: 'GET',
                path: '/notifications/content',
                query: z.object({
                    ...PaginationParams.shape,
                    metadataId: z.number(),
                }),
                responses: {
                    200: paginated(Notification),
                },
            }),
            get: defineEndpoint({
                method: 'GET',
                path: '/notifications/content/:id',
                pathParams: z.object({
                    id: z.number(),
                }),
                responses: {
                    200: Notification,
                },
            }),
            post: defineEndpoint({
                method: 'POST',
                path: '/notifications/content',
                body: Notification,
                responses: {
                    200: Notification,
                },
            }),
            put: defineEndpoint({
                method: 'PUT',
                path: '/notifications/content/:id',
                pathParams: z.object({
                    id: z.number(),
                }),
                body: Notification,
                responses: {
                    200: Notification,
                },
            }),
            getStatus: defineEndpoint({
                method: 'GET',
                path: '/notifications/content/:id/status',
                pathParams: z.object({
                    id: z.number(),
                }),
                responses: {
                    200: z.array(NotificationStatus),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.notification,
    },
);
